export default __webpack_public_path__ + "static/media/pk.35bcd1f9.svg";